import { format } from 'date-fns'

import { DOWNLOAD_API } from '../api'
import { onDownloadLinkClick } from '../components/core-v2'

// Downloads the model portfolio's daily returns (excluding fees) since inception as an .xlsx file.
// The file is named after the model portfolio and suffixed with the download date (ABSA 9349).
export const onDownloadPortfolioExcelClick = (portfolioId: string, portfolioName?: string) => {
  onDownloadLinkClick({
    url: DOWNLOAD_API.exportPortfolioDailyReturnsExcel(portfolioId),
    filename: `${portfolioName || portfolioId}-${format(new Date(), 'yyyy-MM-dd')}.xlsx`,
    method: 'GET'
  })
}
